import {useMemo} from 'react';
import {useLocation} from '@tanstack/react-router';

export default function useQueryParams(): URLSearchParams {
  const location = useLocation();
  const value = useMemo(() => new URLSearchParams(location.search), [location.search]);
  return value;
}
